import { Directive, HostBinding, HostListener, Input } from '@angular/core';
import { Router } from '@angular/router';
import { ActionModel } from '~contentful/models/actions/action.model';
import { LinkModel } from '~contentful/models/actions/link.model';

@Directive({
  selector: '[action]',
})
export class ActionDirective {
  @Input()
  public readonly action: ActionModel;

  @HostBinding('class.pointer')
  public get isClickable() {
    return this.action instanceof LinkModel;
  }

  @HostBinding('attr.href')
  public get href() {
    if (this.action instanceof LinkModel) {
      return this.action?.url;
    }

    return null;
  }

  @HostBinding('attr.target')
  public get target() {
    if (this.action instanceof LinkModel && this.action?.openNewTab) {
      return '_blank';
    }

    return null;
  }

  constructor(private readonly router: Router) {}

  @HostListener('click', ['$event'])
  private click(event: Event) {
    if (this.action instanceof LinkModel) {
      if (this.action?.isInternal && !this.action?.openNewTab) {
        this.preventDefault(event);
        this.router.navigate([this.action.url]);
      }
    }
  }

  private preventDefault(event: Event) {
    event.preventDefault();
    event.returnValue = false;
  }
}
